import { mapGetters } from 'vuex';
import { mapMutations } from 'vuex';

export default {
    props: ["experienceContent", "moreInfo", "multiBooking", "urlExperience", "showExperienceName", "showRoomName", "callSunday", "call"],
    data() {
        return {
            experienceUrl: '',
            currentDay: null,
            keyList: 0,
            multiCalendarCheck: false,
            currentDayPlus: null
        }
    },
    computed: {
        ...mapGetters(['getDateSelected', 'getDesign', 'getMultiCalendar', 'getIdsLink', 'getCheckout', 'isMultiPrice', 'getDisplayMode', 'getCalendarDays', 'getBlockView']),
        multiCalendar: function () {
            this.multiCalendarCheck = this.getMultiCalendar();
            return this.multiCalendarCheck;
        },
        buttonEnabled: function () {
            return this.getCheckout().items.length > 1;
        },
        getCalendars() {
            return this.isMultiPrice() ? this.experienceContent.calendars.filter((obj, index) => index === 0) : this.experienceContent.calendars;
        },
        getMaxPlayers() {
            return this.isMultiPrice() ? this.experienceContent.maxPlayers * this.experienceContent.calendars.length : this.experienceContent.maxPlayers;
        },
        playerMax() {
            return this.getMaxPlayers;
        },
        playerInfo() {
            const rawMin = this.experienceContent.minPlayers;
            const rawMax = this.playerMax;
            const label = this.$t('people');

            const numericMin = Number(rawMin);
            const numericMax = Number(rawMax);

            const hasNumericMin = !Number.isNaN(numericMin);
            const hasNumericMax = !Number.isNaN(numericMax);

            if (hasNumericMin && hasNumericMax && numericMin === 1 && numericMax === 1) {
                return { show: false, text: '' };
            }

            const displayMin = hasNumericMin ? numericMin : rawMin;
            const displayMax = hasNumericMax ? numericMax : rawMax;

            if (hasNumericMin && hasNumericMax && numericMin === numericMax) {
                return { show: true, text: `${displayMin} ${label}` };
            }

            return { show: true, text: `${displayMin} - ${displayMax} ${label}` };
        }
    },
    created() {
        this.currentDay = new Date();
        this.experienceUrl = this.getIdsLink()[this.experienceContent.id];
        this.currentDayPlus = new Date(this.currentDay.getTime() + this.experienceContent.TTC * 60000);
    },
    methods: {
        ...mapMutations(['udpateMultiCalendar']),
        selectSchedule: function () {
            if (!this.multiCalendar) {
                this.$emit('experience-selected');
            }
        },
        setMultiCalendar: function () {
            this.keyList++;
            this.udpateMultiCalendar()
        },
        experienceSelectedButton: function () {
            if (this.buttonEnabled) this.$emit('experience-selected');
        },
        isCalendarDayBlocked() {
            /*
            Ahora se tiene que ver en los dias disponibles del calendario para que tenga en cuenta que si ha
            sido bloqueado o no tenendo encuenta

            1. Cuando se bloquea por días especiales o por la propia experiencia el total es cero
            2. Cuando se bloquea por reservas > calendariios ocuppied >= total

            pero para que se muestre cerrado por bloqueo solo se mostrará cuando el total sea 0
            */



            try {
                const dayCalendar = this.getCalendarDays()[this.getDateSelected()];

                /*
                Existen 3 formas de bloquear calendario

                1. Desde dias especiales --> total = 0
                2. Desde la propia experiencia --> total = 0
                3. Desde el reserva > calendario ---> occupied >= total y a este le afecta la forma en la que se muestra en la experiencia por tanto queda:
                   si this.getBlockView() === 'closed' entonces  occupied >= total
                */

                if (!dayCalendar) {
                    return false;
                }

                if (this.getBlockView() === 'closed') {
                    return dayCalendar.occupied >= dayCalendar.total
                }

                return dayCalendar.total === 0;

            } catch (e) {
                return false;
            }
        }
    }
}
